import {
  // ALERT_WARNING,
  ALERT_ERROR,
  ALERT_SUCCESS,
  // ALERT_INFO
} from './types';

const initialState = {
    message: '',
    type: null,
    active: false
};

const getters = {
    getAlert: state => {
        return state.message
    }
}

const actions = {
    setError: ({ commit }, error) => {
      commit('postError', error)
    },
    setSuccess: ({ commit }, success) => {
      commit('postSuccess', success)
    },
    clearAlert: ({ commit }) => {
      commit('initializeState')
    }
}

const mutations = {
    postError: (state, error) => {
      state.type = ALERT_ERROR;
      state.message = error;
      state.active = true
    },
    postSuccess: (state, success) => {
      state.type = ALERT_SUCCESS;
      state.message = success;
      state.active = true
    },
    initializeState: (state) => {
      state.type = null
      state.message = ''
      state.active = false
    }

}

export default {
    namespaced: true,
    state : initialState,
    getters,
    actions,
    mutations
  }